module.exports = __webpack_public_path__ + "img/wa02.56ce8e8a.jpg";